import React from "react";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Carlos Henrique",
    area: "Morumbi",
    text: "Fiquei parado com a bateria descarregada à noite e a JR Assistência chegou muito rápido. Atendimento excelente e profissional.",
  },
  {
    name: "Ricardo Almeida",
    area: "Campo Limpo",
    text: "Tranquei a chave dentro do carro e resolveram o problema sem causar nenhum dano. Serviço de qualidade.",
  },
  {
    name: "Juliana Martins",
    area: "Taboão da Serra",
    text: "Atendimento nota 10. O técnico chegou rápido e fez a carga da bateria na hora. Muito eficiente.",
  },
  {
    name: "Marcos Oliveira",
    area: "Morumbi",
    text: "Empresa séria, pontual e confiável. Sempre que precisei fui muito bem atendido.",
  },
  {
    name: "Patrícia Lima",
    area: "Campo Limpo",
    text: "Furei o pneu e não sabia trocar. A equipe chegou rapidamente e resolveu tudo. Excelente atendimento.",
  },
];

const initials = (name) =>
  name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

export default function Testimonials() {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32 bg-[#050505] noise-overlay"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-3xl mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#f3bd0e]/40 rounded-sm mb-5">
            <span className="w-1.5 h-1.5 bg-[#f3bd0e]"></span>
            <span className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#f3bd0e]">
              Quem confia, recomenda
            </span>
          </div>
          <h2
            className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight text-white"
            data-testid="testimonials-title"
          >
            O que nossos <span className="text-[#f3bd0e]">clientes</span> dizem
          </h2>
          <div className="mt-5 flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-5 h-5 text-[#f3bd0e]"
                  fill="#f3bd0e"
                />
              ))}
            </div>
            <span className="text-white/70 text-sm">
              <span className="font-bold text-white">5.0</span> · Avaliação média
              em mais de 500 atendimentos
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, idx) => (
            <article
              key={t.name}
              data-testid={`testimonial-${idx}`}
              className="relative bg-black border border-white/10 rounded-lg p-7 hover:border-[#f3bd0e]/50 transition group"
            >
              <Quote className="absolute top-5 right-5 w-9 h-9 text-[#f3bd0e]/20 group-hover:text-[#f3bd0e]/40 transition" />
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 text-[#f3bd0e]"
                    fill="#f3bd0e"
                  />
                ))}
              </div>
              <p className="text-white/85 leading-relaxed text-[15px] italic">
                “{t.text}”
              </p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-white/10">
                <div className="w-11 h-11 rounded-md bg-[#f3bd0e] text-black flex items-center justify-center font-display text-base">
                  {initials(t.name)}
                </div>
                <div>
                  <div className="font-display text-sm uppercase tracking-tight text-white">
                    {t.name}
                  </div>
                  <div className="text-[11px] uppercase tracking-wider text-[#f3bd0e]">
                    {t.area}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
